export default {
  header: {
    back: {
      url: 'http://chaumet.com',
      content: 'Back to Chaumet.com'
    }
  },
  playerCover: {
    title: 'The Worlds <br> of Chaumet',
    content: 'From 28 June to 17 September 2018',
    idYt: 'aXMgQ6xpdPg',
    cover: 'home/player/cover.jpg',
    legend: 'Video'
  },
  scrollCta: 'scroll to see more',
  worldDiscover: {
    title: {
      firstPart: 'Discover',
      secondPart: 'The Worlds'
    },
    content:
      'For the occasion of the exhibition at the Mitsubischi Ichigokan Museum of Tokyo, Chaumet takes you on a new journey into the history, culture, expertise and the style of the Maison.',
    worlds: {
      types: [
        {
          title: 'Joséphine',
          content: 'The Chaumet woman, muse of the Maison.',
          img: 'home/world/josephine.jpg',
          url: 'josephine'
        },
        {
          title: 'Maison Chaumet',
          content: 'The first jeweller of Place Vendôme, at number 12.',
          img: 'home/world/chaumet.jpg',
          url: 'maison'
        },
        {
          title: 'Chaumet and Japan',
          content: 'An invitation to travel.',
          img: 'home/world/japon.jpg',
          url: 'japan'
        },
        {
          title: 'Nature',
          content: 'An infinite source of inspiration.',
          img: 'home/world/nature.jpg',
          url: 'nature'
        },
        {
          title: 'The art of the tiara',
          content: 'With creation in mind.',
          img: 'home/world/art.jpg',
          url: 'tiara'
        },
        {
          title: 'A choice of sovereigns',
          content: 'The papal tiara of Pope Pius VII, symbol of power.',
          img: 'home/world/pape.jpg',
          url: 'sovereigns'
        },
        {
          title: 'Les bijoux de sentiment',
          content: 'Célébrer les grands moments de bonheur.',
          img: 'home/world/sentimental.jpg',
          url: 'sentimental'
        },
        {
          title: 'L’art du bijou transformable',
          content: 'Le savoir-faire et la virtuosité.',
          img: 'home/world/transformer.jpg',
          url: 'transformer'
        }
      ],
      cta: 'Discover'
    },
    legend: 'Worlds'
  },
  wall: {
    title: '#TheWorldsOfChaumet',
    content:
      'The exhibition illustrates the way in which Chaumet opened up to the whole world from the second half of the 19th century, capturing the most diverse influences, spreading his Parisian style in return, and establishing himself as a major player in the history of taste. Chaumet pays a special tribute to Japan and Japanese culture, with which it has had close ties since the end of the 18th century.',
    previous: 'Previous',
    next: 'Next',
    cta: 'see more',
    legend: '#TheWorldsOfChaumet'
  },
  footer: {
    title: 'Practical information',
    exposition: {
      title: 'The Worlds of Chaumet exhibition',
      content:
        'From 28 June to 17 September 2018, at the Mitsubischi Ichigokan Museum in Tokyo.'
    },
    museum: {
      link: {
        title: 'Access the museum website',
        url: 'https://mimt.jp/chaumet/'
      },
      logo: 'home/museum-logo.png'
    },
    legend: 'Practical information',
    links: [
      { logo: 'social/fb.png', url: 'https://www.facebook.com/Chaumet' },
      {
        logo: 'social/insta.png',
        url: 'https://www.instagram.com/chaumetofficial/'
      },
      { logo: 'social/yt.png', url: 'https://youtube.com/user/Chaumet' },
      { logo: 'social/gplus.png', url: 'https://plus.google.com/+chaumet' },
      { logo: 'social/pint.png', url: 'https://www.pinterest.fr/chaumet/' },
      { logo: 'social/twitter.png', url: 'https://twitter.com/Chaumet' },
      {
        logo: 'social/line.png',
        url: 'https://line.me/R/ti/p/%40chaumetofficial'
      },
      { logo: 'social/wechat.png' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/locales/en/home.js